import { render, staticRenderFns } from "./PromocodeEditModalNew.vue?vue&type=template&id=3647d15c&scoped=true"
import script from "./PromocodeEditModalNew.vue?vue&type=script&lang=js"
export * from "./PromocodeEditModalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647d15c",
  null
  
)

export default component.exports